export default __webpack_public_path__ + "static/media/Rajendra.db65c062.jpeg";